import Cookies from 'js-cookie';

export function getAllowSocialMedia(): boolean {
  const rawCookieData = Cookies.get('cookie-consent');

  if (rawCookieData) {
    try {
      const cookies = JSON.parse(rawCookieData);
      return cookies && cookies.settings?.includes('ads');
    } catch (error) {
      console.warn('Failed to parse cookie-consent data:', error);
      return false;
    }
  }
  return false;
}
